var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.updateHandler}},[_vm._v(" "+_vm._s(_vm.$t('updateData'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }